import {
  createContext,
  useContext,
  useMemo,
  type ReactNode,
} from "react";
import { createMongoAbility, type MongoAbility } from "@casl/ability";
import { createContextualCan } from "@casl/react";
import type { AbilityRule } from "@/lib/api/user";

type AppAbility = MongoAbility;

const AbilityContext = createContext<AppAbility>(createMongoAbility());

export const Can = createContextualCan(AbilityContext.Consumer);

export function AbilityProvider({
  rules,
  children,
}: {
  rules: AbilityRule[] | undefined;
  children: ReactNode;
}) {
  const ability = useMemo(
    () => createMongoAbility(rules ?? []),
    [rules],
  );

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
}

export function useAbility(): AppAbility {
  return useContext(AbilityContext);
}
